export default "__VITE_ASSET__DNAKihvP__"